module.exports = __webpack_public_path__ + "static/media/logo_polar_white.c7dd99a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo_polar_white.png
// module id = 1530
// module chunks = 0